import { View } from "react-native-web";
import { CImage } from "../../../components/atoms";
import { Constants, Images } from "../../../config";

export const zooFilterCriteria = (isMobileVersion, styles) => {
  return [
    {
      title: "Location",
      isHide: isMobileVersion,
      isLocation: true,
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_STATUS,
      icon: Images.iconTagStatus,
      width: 20,
      height: 20,
      title: "Status",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Open",
          tagId: 1,
        },
        {
          id: 2,
          label: "Closed",
          tagId: 2,
        },
        {
          id: 3,
          label: "Temporarily Closed",
          tagId: 4,
        },
        {
          id: 4,
          label: "Permanently Closed",
          tagId: 3,
        },
      ],
      selectedList: [1, 2, 4],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_ZOO_CATEGORY,
      icon: Images.iconTagFeature,
      width: 20,
      height: 20,
      title: "Category",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Zoo",
          tagId: 4001,
        },
        {
          id: 2,
          label: "Wildlife Park",
          tagId: 4002,
        },
        {
          id: 3,
          label: "Animal sanctuary",
          tagId: 4003,
        },
        {
          id: 4,
          label: "Aquarium",
          tagId: 4004,
        },
        {
          id: 5,
          label: "Marine mammal park",
          tagId: 4005,
        },
        {
          id: 6,
          label: "Penguinarium",
          tagId: 4006,
        },
        {
          id: 7,
          label: "Dolphinarium",
          tagId: 4007,
        },
        {
          id: 8,
          label: "Nocturnal house",
          tagId: 4008,
        },
        {
          id: 9,
          label: "Aviary",
          tagId: 4009,
        },
        {
          id: 10,
          label: "Petting zoo",
          tagId: 4010,
        },
        {
          id: 11,
          label: "Animal theme park",
          tagId: 4011,
        },
        {
          id: 12,
          label: "Reptilarium",
          tagId: 4012,
        },
        {
          id: 13,
          label: "Herpetarium",
          tagId: 4013,
        },
        {
          id: 14,
          label: "Serpentarium",
          tagId: 4014,
        },
        {
          id: 15,
          label: "Farm",
          tagId: 4015,
        },
        {
          id: 16,
          label: "Oceanarium",
          tagId: 4016,
        },
      ],
      selectedList: [],
    },
    // {
    //   id: Constants.tagCategory.TAG_CATEGORY_ANIMAL_LINKED,
    //   icon: Images.iconTagSize,
    //   width: 20,
    //   height: 20,
    //   title: "Animals Linked",
    //   isHide: false,
    //   detailList: [
    //     {
    //       id: 0,
    //       label: "N/A",
    //       value: null,
    //     },
    //     {
    //       id: 1,
    //       label: "0-10",
    //       value: { minValue: 0, maxValue: 10 },
    //     },
    //     {
    //       id: 2,
    //       label: "11-50",
    //       value: { minValue: 11, maxValue: 50 },
    //     },
    //     {
    //       id: 3,
    //       label: "51-100",
    //       value: { minValue: 51, maxValue: 100 },
    //     },
    //     {
    //       id: 4,
    //       label: "101-200",
    //       value: { minValue: 101, maxValue: 200 },
    //     },
    //     {
    //       id: 5,
    //       label: "+200",
    //       value: { minValue: 200 },
    //     },
    //   ],
    //   selectedList: [],
    // },
    {
      id: Constants.tagCategory.TAG_CATEGORY_ZOO_SPECIES,
      icon: Images.iconTagSize,
      width: 20,
      height: 20,
      title: "Animals",
      isHide: false,
      isRangeValue: true,
      detailList: [
        {
          id: 0,
          label: "N/A",
          value: null,
        },
        {
          id: 1,
          label: "0-10",
          value: { minValue: 0, maxValue: 10 },
        },
        {
          id: 2,
          label: "11-50",
          value: { minValue: 11, maxValue: 50 },
        },
        {
          id: 3,
          label: "51-100",
          value: { minValue: 51, maxValue: 100 },
        },
        {
          id: 4,
          label: "101-200",
          value: { minValue: 101, maxValue: 200 },
        },
        {
          id: 5,
          label: "201-500",
          value: { minValue: 201, maxValue: 500 },
        },
        {
          id: 6,
          label: "+500",
          value: { minValue: 500 },
        },
      ],
      selectedList: [],
    },
    // {
    //   id: Constants.tagCategory.TAG_CATEGORY_ZOO_SPECIES,
    //   icon: Images.iconTagSize,
    //   width: 20,
    //   height: 20,
    //   title: "Population",
    //   isHide: false,
    //   isRangeValue: true,
    //   detailList: [
    //     {
    //       id: 0,
    //       label: "N/A",
    //       value: null,
    //     },
    //     {
    //       id: 1,
    //       label: "0-100",
    //       value: { minValue: 0, maxValue: 100 },
    //     },
    //     {
    //       id: 2,
    //       label: "100-500",
    //       value: { minValue: 100, maxValue: 500 },
    //     },
    //     {
    //       id: 3,
    //       label: "500-1,000",
    //       value: { minValue: 500, maxValue: 1000 },
    //     },
    //     {
    //       id: 4,
    //       label: "1,000-2,000",
    //       value: { minValue: 1000, maxValue: 2000 },
    //     },
    //     {
    //       id: 5,
    //       label: "+2,000",
    //       value: { minValue: 2000 },
    //     },
    //   ],
    //   selectedList: [],
    // },
    {
      id: Constants.tagCategory.TAG_CATEGORY_SIZE_SQM,
      icon: Images.iconTagSize,
      width: 20,
      height: 20,
      title: "Size",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "XS - 0-10k sqm",
          tagId: 4601,
        },
        {
          id: 2,
          label: "S - 10-100k sqm",
          tagId: 4602,
        },
        {
          id: 3,
          label: "M - 100k-1m sqm",
          tagId: 4603,
        },
        {
          id: 4,
          label: "L - 1-10 sqkm",
          tagId: 4604,
        },
        {
          id: 5,
          label: "XL - 10-100 sqkm",
          tagId: 4605,
        },
        {
          id: 6,
          label: "XXL - +100 sqkm",
          tagId: 4606,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_PRICE,
      icon: Images.iconTagPrice,
      width: 20,
      height: 20,
      title: "Price",
      isHide: true,
      isRangeValue: true,
      detailList: [
        {
          id: 1,
          label: "$0 - $5",
          value: { minValue: 0, maxValue: 5 },
        },
        {
          id: 2,
          label: "$5 - $10",
          value: { minValue: 5, maxValue: 10 },
        },
        {
          id: 3,
          label: "$10 - $20",
          value: { minValue: 10, maxValue: 20 },
        },
        {
          id: 4,
          label: "$20 - $50",
          value: { minValue: 20, maxValue: 50 },
        },
        {
          id: 5,
          label: "+$50",
          value: { minValue: 50 },
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_RATING,
      icon: Images.iconTagRating,
      width: 21.5,
      height: isMobileVersion ? 21 : 20,
      title: "Rating",
      isHide: true,
      isRating: true,
      detailList: [
        {
          id: 1,
          label: "1",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating1}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 2,
          label: "2",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating2}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 3,
          label: "3",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating3}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 4,
          label: "4",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating4}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 5,
          label: "5",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating5}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
      ],
      selectedList: [],
    },
  ];
};
